export const itemList = {
  cakes: [
    {
      img: "images/cakes/cake1.png",
      alt: "Cake",
      title: "Black Gateu Wedding Cake",
      text: "A luxurious chocolate gateau, perfect for a sophisticated wedding celebration.",
      price: 250,
    },
    {
      img: "images/cakes/cake2.jpg",
      alt: "Cake",
      title: "Velvet Deluxe Wedding Cake",
      text: "A rich velvet cake layered with cream cheese frosting, ideal for a grand wedding.",
      price: 230,
    },
    {
      img: "images/cakes/cake3.jpg",
      alt: "Cake",
      title: "Elegant Dreams Wedding Cake",
      text: "An elegant wedding cake adorned with delicate floral decorations.",
      price: 160,
    },
    {
      img: "images/cakes/cake4.jpg",
      alt: "Cake",
      title: "Vanilla Flower Birthday Cake",
      text: "A classic vanilla cake with a beautiful floral design, perfect for birthdays.",
      price: 50,
    },
    {
      img: "images/cakes/cake5.jpg",
      alt: "Cake",
      title: "Carrot Cream Cake",
      text: "A moist carrot cake with cream cheese frosting, offering a delightful taste.",
      price: 35,
    },
    {
      img: "images/cakes/cake6.jpg",
      alt: "Cake",
      title: "Fruit Power Forest Cake",
      text: "A fruity forest cake topped with a mix of seasonal fruits and whipped cream.",
      price: 35,
    },
    {
      img: "images/cakes/cake7.jpg",
      alt: "Cake",
      title: "Elegant Wisdom Cake",
      text: "An elegant cake with a sophisticated design, ideal for special occasions.",
      price: 150,
    },
    {
      img: "images/cakes/cake8.jpg",
      alt: "Cake",
      title: "Blackberry Supreme Cake",
      text: "A rich cake infused with blackberry flavors and topped with a berry compote.",
      price: 80,
    },
    {
      img: "images/cakes/cake9.jpg",
      alt: "Cake",
      title: "Queen's Caramel Cake",
      text: "A decadent caramel cake with layers of smooth caramel frosting.",
      price: 110,
    },
  ],
  pastries: [
    {
      img: "images/pastries/pastry1.jpg",
      alt: "Cheese Pastry with Sesame Seed",
      title: "Cheese Pastry with Sesame Seed",
      text: "A savory pastry filled with creamy cheese and topped with crunchy sesame seeds.",
      price: 3,
    },
    {
      img: "images/pastries/pastry2.jpg",
      alt: "Croissant",
      title: "Classic Croissant",
      text: "A buttery, flaky croissant, perfect for breakfast or an afternoon snack.",
      price: 2.5,
    },
    {
      img: "images/pastries/pastry3.jpg",
      alt: "Ham Cheese and Mayo Bun",
      title: "Ham, Cheese, and Mayo Bun",
      text: "A soft bun filled with ham, melted cheese, and a hint of mayo for a savory treat.",
      price: 3.5,
    },
    {
      img: "images/pastries/pastry4.jpg",
      alt: "Cherry Puff Pastry",
      title: "Cherry Puff Pastry",
      text: "A light and crispy puff pastry filled with sweet cherry filling.",
      price: 3,
    },
    {
      img: "images/pastries/pastry5.jpg",
      alt: "Cinnamon Bun",
      title: "Cinnamon Bun",
      text: "A soft bun swirled with cinnamon and sugar, topped with a sweet glaze.",
      price: 2.5,
    },
    {
      img: "images/pastries/pastry6.jpg",
      alt: "Jambon Pastry",
      title: "Jambon",
      text: "A savory puff pastry filled with ham and cheese, baked to golden perfection.",
      price: 4,
    },
    {
      img: "images/pastries/pastry7.jpg",
      alt: "Macarons",
      title: "Assorted Macarons",
      text: "Delicate French macarons with a variety of flavored fillings.",
      price: 1.5,
    },
    {
      img: "images/pastries/pastry8.jpg",
      alt: "Pecan Pastry with Glaze",
      title: "Pecan Pastry with Glaze",
      text: "A rich pastry topped with pecans and a sweet caramel glaze.",
      price: 4,
    },
    {
      img: "images/pastries/pastry9.jpg",
      alt: "Mini Sausage Rolls",
      title: "Mini Sausage Rolls",
      text: "Flaky puff pastry wrapped around seasoned sausage for a savory snack.",
      price: 5,
    },
  ],
  doughnuts: [
    {
      img: "images/donuts/donut1.jpg",
      alt: "Vanilla Cream Doughnut",
      title: "Vanilla Cream Doughnut",
      text: "Soft doughnut filled with rich vanilla cream and topped with a light glaze.",
      price: 3,
    },
    {
      img: "images/donuts/donut2.jpg",
      alt: "Caramel Nuts Doughnut",
      title: "Caramel Nuts Doughnut",
      text: "Decadent doughnut with a caramel glaze and crunchy nuts on top.",
      price: 3.5,
    },
    {
      img: "images/donuts/donut3.jpg",
      alt: "Vanilla Caramel Nuts Doughnut",
      title: "Vanilla Caramel Nuts Doughnut",
      text: "A delicious combination of vanilla cream and caramel glaze with nuts.",
      price: 4,
    },
    {
      img: "images/donuts/donut4.jpg",
      alt: "Cherry Filled Doughnut",
      title: "Cherry Filled Doughnut",
      text: "Doughnut bursting with sweet cherry filling and dusted with powdered sugar.",
      price: 3.5,
    },
    {
      img: "images/donuts/donut5.jpg",
      alt: "Christmas Doughnut",
      title: "Christmas Doughnut",
      text: "Festive doughnut topped with holiday-themed decorations and sprinkles.",
      price: 4,
    },
    {
      img: "images/donuts/donut6.jpg",
      alt: "Marmalade Filled Doughnut",
      title: "Marmalade Filled Doughnut",
      text: "A tangy marmalade-filled doughnut with a sweet sugar coating.",
      price: 3.5,
    },
    {
      img: "images/donuts/donut7.jpg",
      alt: "Pink Floss Doughnut",
      title: "Pink Floss Doughnut",
      text: "A playful doughnut topped with pink cotton candy-flavored frosting.",
      price: 3.5,
    },
    {
      img: "images/donuts/donut8.jpg",
      alt: "Cookies N' Cream Doughnut",
      title: "Cookies N' Cream Doughnut",
      text: "A rich doughnut topped with crumbled cookies and cream frosting.",
      price: 4,
    },
    {
      img: "images/donuts/donut9.jpg",
      alt: "Custard Filled Doughnut",
      title: "Custard Filled Doughnut",
      text: "Creamy custard-filled doughnut with a lightly glazed exterior.",
      price: 3.5,
    },
  ],
  cookies: [
    {
      img: "images/cookies/cookies1.jpg",
      alt: "Crinkled Chip Cookies",
      title: "Crinkled Chip Cookies",
      text: "Delicious chocolate chip cookies with a crinkled top and soft, chewy center.",
      price: 5,
    },
    {
      img: "images/cookies/cookies2.jpg",
      alt: "Gluten Free Thin Cookies",
      title: "Gluten Free Thin Cookies",
      text: "Light, crispy cookies made without gluten but full of flavor.",
      price: 4.5,
    },
    {
      img: "images/cookies/cookies3.jpg",
      alt: "Christmas Cookies",
      title: "Christmas Cookies",
      text: "Festive cookies with a hint of cinnamon, perfect for the holiday season.",
      price: 6,
    },
    {
      img: "images/cookies/cookies4.jpg",
      alt: "Rocky Road Cookies",
      title: "Rocky Road Cookies",
      text: "Rich cookies filled with marshmallows, nuts, and chocolate chips.",
      price: 5.5,
    },
    {
      img: "images/cookies/cookies5.jpg",
      alt: "Star Vanilla Cookies",
      title: "Star Vanilla Cookies",
      text: "Delicate vanilla-flavored cookies shaped like stars.",
      price: 4,
    },
    {
      img: "images/cookies/cookies6.jpg",
      alt: "Granola Raisin Cookies",
      title: "Granola Raisin Cookies",
      text: "Healthy cookies packed with granola and raisins for a wholesome treat.",
      price: 5,
    },
    {
      img: "images/cookies/cookies7.jpg",
      alt: "Chocolate Chip",
      title: "Chocolate Chip Cookies",
      text: "Classic chocolate chip cookies with gooey centers and crispy edges.",
      price: 5,
    },
    {
      img: "images/cookies/cookies8.jpg",
      alt: "White Cashew Cookies",
      title: "White Cashew Cookies",
      text: "Buttery cookies with white chocolate and cashews for a rich flavor.",
      price: 6,
    },
    {
      img: "images/cookies/cookies9.jpg",
      alt: "Heart Cookies",
      title: "Heart Cookies",
      text: "Sweet heart-shaped cookies perfect for gifting or indulging yourself.",
      price: 5.5,
    },
  ],
};
